import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "px-6 py-2",
  id: "tab-autoIDs"
};
const _hoisted_2 = {
  class: "flex w-full"
};
const _hoisted_3 = {
  class: "w-6/12"
};
const _hoisted_4 = ["onClick", "onMouseenter"];
const _hoisted_5 = {
  class: "w-6/12 pl-4"
};
const _hoisted_6 = {
  class: "table table-condensed timesheet-table"
};
const _hoisted_7 = {
  class: "ll-name cursor-pointer"
};
const _hoisted_8 = {
  class: "ll-name"
};
const _hoisted_9 = {
  class: "cursor-pointer text-gray-400"
};
const _hoisted_10 = {
  class: "text-error"
};
const _hoisted_11 = {
  class: "text-error"
};
const _hoisted_12 = {
  class: "cursor-pointer text-gray-400"
};
const _hoisted_13 = {
  class: "text-error"
};
const _hoisted_14 = {
  class: "text-error"
};
const _hoisted_15 = {
  class: "cursor-pointer text-gray-400"
};
const _hoisted_16 = {
  class: "text-error"
};
const _hoisted_17 = {
  class: "text-error"
};
const _hoisted_18 = {
  class: "span5"
};
const _hoisted_19 = {
  key: 0,
  class: "text-error text-sm mt-1"
};
import MainHeader from "@/components/MainHeader.vue";
import SettingsSaveBar from "@/components/SettingsSaveBar.vue";
import { onMounted, reactive, computed } from "vue";
import RouteService from "@/services/RouteService";
import { useCompanyStore } from "@/services/UserService/useCompanyStore";
import { useAutoIDStore } from "@/services/AutoIDStore/useAutoIDStore";
export default {
  __name: 'CompanyAutoIDs',
  props: {
    userService: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const companyStore = useCompanyStore();
    const autoIDStore = useAutoIDStore();
    const autoIDState = reactive({
      me: {},
      loading: false,
      autoIdOptions: {},
      preview: [],
      saving: false,
      unsaved: false
    });
    const settings = reactive({
      pattern: '',
      nextNumber: 0,
      year: 0
    });
    onMounted(async () => {
      autoIDState.loading = true;
      const me = await props.userService.me();
      autoIDState.autoIdOptions = await autoIDStore.assignOptions(me);
      autoIDState.me = me;
      Object.assign(settings, me.company.settings.references);
      autoIDState.pattern = settings.pattern;

      // Ensure nextNumber is at least 1
      autoIDState.nextNumber = settings.nextNumber >= 1 ? settings.nextNumber : 1;
      showPreview(autoIDState.autoIdOptions[autoIDState.pattern]);
      autoIDState.loading = false;
      const deactivate = new RouteService(props).rootScopeChange().$on("$stateChangeStart", event => {
        if (somethingChanged.value) {
          autoIDState.unsaved = true;
          setTimeout(() => {
            autoIDState.unsaved = false;
          }, 4000);
          event.preventDefault();
        } else {
          deactivate();
        }
      });
    });
    function showPreview(option) {
      // Use a default value of 1 for preview when nextNumber is not valid. This page will fail to load if the number is less than 1.
      const previewNumber = autoIDState.nextNumber && autoIDState.nextNumber >= 1 ? autoIDState.nextNumber : 1;
      autoIDState.preview = option.preview(previewNumber);
    }
    function setOption(option) {
      autoIDState.pattern = option.pattern;
    }
    const showPreviewItems = computed(() => {
      // Use a default value of 1 for preview when nextNumber is not valid
      const previewNumber = autoIDState.nextNumber && autoIDState.nextNumber >= 1 ? autoIDState.nextNumber : 1;
      return autoIDState.autoIdOptions[autoIDState.pattern].preview(previewNumber);
    });
    function cancel() {
      autoIDState.nextNumber = settings.nextNumber;
      autoIDState.pattern = settings.pattern;
    }

    // Function to validate and clean up the next number input
    function validateNextNumber(event) {
      // Get the input value
      const value = event.target.value;

      // If the value is empty or invalid, set to empty string to show the validation error
      if (value === '' || value === null || value === undefined || Number(value) < 1) {
        // Clear the input but keep track of its invalid state
        autoIDState.nextNumber = value === '' ? '' : Number(value);
      } else {
        // Valid input, ensure it's a number
        autoIDState.nextNumber = Number(value);
      }
    }
    async function save() {
      // Validate next number before proceeding
      if (!isValidNextNumber.value) {
        props.alerts.error("Number must be 1 or greater");
        return;
      }
      autoIDState.saving = true;
      const d = new Date();
      const _currYear = d.getFullYear();
      try {
        // Store current values 
        const newPattern = String(autoIDState.pattern);
        const newNextNumber = Number(autoIDState.nextNumber);

        // Create payload for API call
        const payload = {
          settings: {
            references: {
              pattern: newPattern,
              nextNumber: newNextNumber,
              year: _currYear
            }
          }
        };

        // Call API
        await companyStore.updateMyCompany(payload);
        settings.pattern = newPattern;
        settings.nextNumber = newNextNumber;
        settings.year = _currYear;
        autoIDState.pattern = newPattern;
        autoIDState.nextNumber = newNextNumber;
        props.alerts.success("Your settings were saved.");
      } catch (err) {
        props.alerts.error(err);
      } finally {
        autoIDState.saving = false;
      }
    }
    const somethingChanged = computed(() => {
      if (settings.nextNumber !== autoIDState.nextNumber) {
        return true;
      }
      if (settings.pattern !== autoIDState.pattern) {
        return true;
      }
      return false;
    });

    // Validation property used for both inline message and save button state
    const isValidNextNumber = computed(() => {
      const num = Number(autoIDState.nextNumber);
      return !isNaN(num) && num >= 1;
    });
    return (_ctx, _cache) => {
      return !autoIDState.loading && autoIDState.preview.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MainHeader, {
        content: `Client and ${autoIDState.me?.terms?.Matter} IDs`
      }, null, 8, ["content"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, " Changes will apply to new clients and " + _toDisplayString(autoIDState.me?.terms?.matter) + "s. Existing clients and " + _toDisplayString(autoIDState.me?.terms?.matter) + "s will not be affected. ", 1), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(autoIDState.autoIdOptions, (option, idx) => {
        return _openBlock(), _createElementBlock("button", {
          type: "button",
          class: _normalizeClass(["idselection flex flex-col", {
            'option-active': option.pattern === autoIDState.pattern
          }]),
          key: idx,
          onClick: $event => setOption(option),
          onMouseenter: $event => showPreview(option),
          onMouseleave: _cache[0] || (_cache[0] = $event => showPreview(autoIDState.autoIdOptions[autoIDState.pattern]))
        }, [_createElementVNode("h5", null, [_createElementVNode("b", null, _toDisplayString(option.label), 1)]), _createElementVNode("p", null, _toDisplayString(option.description), 1)], 42, _hoisted_4);
      }), 128))])]), _createElementVNode("div", _hoisted_5, [_cache[13] || (_cache[13] = _createElementVNode("h4", {
        class: "text-center"
      }, "Example Preview", -1)), _createElementVNode("table", _hoisted_6, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[4] || (_cache[4] = _createElementVNode("th", {
        class: "ll-name cursor-pointer"
      }, "Client Id", -1)), _cache[5] || (_cache[5] = _createElementVNode("th", {
        class: "ll-name cursor-pointer"
      }, "Client Name", -1)), _createElementVNode("th", _hoisted_7, _toDisplayString(autoIDState.me?.terms?.Matter) + " Id ", 1), _createElementVNode("th", _hoisted_8, _toDisplayString(autoIDState.me?.terms?.Matter) + " Name", 1)])]), _createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_9, [_createElementVNode("td", _hoisted_10, _toDisplayString(showPreviewItems.value[0]?.client), 1), _cache[6] || (_cache[6] = _createElementVNode("td", {
        class: "ll-name"
      }, "Adams, Bob", -1)), _createElementVNode("td", _hoisted_11, _toDisplayString(showPreviewItems.value[0]?.matter), 1), _cache[7] || (_cache[7] = _createElementVNode("td", {
        class: "ll-name"
      }, "General", -1))]), _createElementVNode("tr", _hoisted_12, [_createElementVNode("td", _hoisted_13, _toDisplayString(showPreviewItems.value[1]?.client), 1), _cache[8] || (_cache[8] = _createElementVNode("td", {
        class: "ll-name"
      }, "Clark, Mary", -1)), _createElementVNode("td", _hoisted_14, _toDisplayString(showPreviewItems.value[1]?.matter), 1), _cache[9] || (_cache[9] = _createElementVNode("td", {
        class: "ll-name"
      }, "General", -1))]), _createElementVNode("tr", _hoisted_15, [_createElementVNode("td", _hoisted_16, _toDisplayString(showPreviewItems.value[2]?.client), 1), _cache[10] || (_cache[10] = _createElementVNode("td", {
        class: "ll-name"
      }, "Clark, Mary", -1)), _createElementVNode("td", _hoisted_17, _toDisplayString(showPreviewItems.value[2]?.matter), 1), _cache[11] || (_cache[11] = _createElementVNode("td", {
        class: "ll-name"
      }, "Bankruptcy", -1))])])]), _withDirectives(_createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("label", null, "Starting/Next Client Number", 512), [[_vShow, autoIDState.autoIdOptions[autoIDState.pattern].usingClientOnlyID || autoIDState.autoIdOptions[autoIDState.pattern].usingClientAndMatterID]]), _withDirectives(_createElementVNode("label", null, "Starting/Next " + _toDisplayString(autoIDState.me?.terms?.Matter) + " Number", 513), [[_vShow, autoIDState.autoIdOptions[autoIDState.pattern].usingMatterOnlyID]]), _cache[12] || (_cache[12] = _createTextVNode()), _withDirectives(_createElementVNode("input", {
        type: "number",
        step: "1",
        min: "1",
        class: _normalizeClass({
          'border-[rgb(var(--v-theme-error))]': !isValidNextNumber.value
        }),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => autoIDState.nextNumber = $event),
        onInput: validateNextNumber,
        name: "nextClientOrMatterNumber",
        required: ""
      }, null, 34), [[_vModelText, autoIDState.nextNumber, void 0, {
        number: true
      }]]), !isValidNextNumber.value ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Number must be 1 or greater ")) : _createCommentVNode("", true)], 512), [[_vShow, autoIDState.autoIdOptions[autoIDState.pattern].nextNumberRequired]])])]), _cache[14] || (_cache[14] = _createTextVNode()), _createVNode(SettingsSaveBar, {
        somethingChanged: somethingChanged.value,
        saving: autoIDState.saving,
        unsaved: autoIDState.unsaved,
        disabled: !isValidNextNumber.value,
        onUpdate: _cache[2] || (_cache[2] = $event => save()),
        onCancel: _cache[3] || (_cache[3] = $event => cancel())
      }, null, 8, ["somethingChanged", "saving", "unsaved", "disabled"])])) : _createCommentVNode("", true);
    };
  }
};